import axios from "axios"
import { apiInstance } from "./api"
import { getServiceBaseUrl } from "./api"
import { store } from "@redux"
import { isInPosDevice } from "utils"

const endpoint = "/setting"

export const getSettings = async () => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}`)

  return response.data
}

export const setTemporaryOff = async (data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/temporaryOff`, data)

  return response.data
}

export const editSettings = async data => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}`, data)

  return response.data
}

export const getShareholders = async () => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/shareholder`)

  return response.data
}

export const fetchSystemPrinters = async () => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/print`)

  return response.data
}

export const getCashierAccesses = async () => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/access`)

  return response.data
}

export const isServerAlive = async () => {
  const { systemSettings: { domain } } = store.getState()

  let query = ""

  if (isInPosDevice()) {
    const random = String(Date.now())

    query = random ? `?random=${random}` : ""
  }

  const url =
    `${getServiceBaseUrl(
      domain,
      "main",
      process.env.REACT_APP_API_MAIN_URL ||
        process.env.REACT_APP_API_BASE_URL
    )}setting/generate_204${query}`

  const response = await axios.get(url, { timeout: 10000 })

  return response.data
}
